import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-market-termcondition',
  templateUrl: './modal-market-termcondition.component.html',
  styleUrls: ['./modal-market-termcondition.component.scss']
})
export class ModalMarketTermconditionComponent implements OnInit {

  @ViewChild('termConditionModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-lg', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  
  callback: Function;
  title: any = '';
  content: any = '';
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onMarketTermcondition.subscribe(req => {
      this.title = '';
      this.content = '';
      this.title = req.title;
      this.content = req.content;
      this.callback = req.callback;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketTermconditionHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm(): void {
    this.isShow = false;
    this.callback({status: 'confirm'});
    if(this.modalRef){
      this.modalRef.hide();
    }
  }

}
